import AuthRoutes from "../components/pages/auth/AuthRoute";
import DashboardRoutes from "../components/pages/dashboard/DashboardRoute";
import OutputRoute from "../components/pages/auth/OutputRoute";

export const standardRoutes = [...DashboardRoutes, ...OutputRoute];

export const guestRoutes = [...AuthRoutes, ...OutputRoute];
